<template>
  <div class="index-container">
    <!--main-header start-->
    <Header
      class="index-header"
      :tabColor="state.tabColor"
      :titleUrl="require('../assets/images/logo3.png')"
      :userName="userName"
      @clickItem="getTabIndex"
      @clickLogin="loginBtn"
    />

    <div class="swiper mySwiper">
      <swiper
        :autoplay="{ delay: 15000 }"
        :loop="true"
        :centeredSlides="true"
        :navigation="{
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }"
        :pagination="{
          el: '.swiper-pagination',
          clickable: true,
          renderBullet: (index, className) => {
            return `<span class='${className}'> ${index + 1}</span>`;
          },
        }"
        @init="init"
        @slide-change-transition-end="slideChangeTransitionEnd"
        :modules="modules"
        class="mySwiper"
      >
        <swiper-slide>
          <div class="index-banner bg1">
            <a>
              <img
                class="ani"
                swiper-animate-effect="fadeInUp"
                src="../assets/images/txt1.png"
              />
            </a>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="index-banner bg2">
            <a>
              <img
                class="ani"
                swiper-animate-effect="fadeInUp"
                src="../assets/images/txt2.png"
              />
            </a></div
        ></swiper-slide>
        <swiper-slide>
          <div class="index-banner bg3">
            <a>
              <img
                class="ani"
                swiper-animate-effect="fadeInUp"
                src="../assets/images/txt3.png"
              />
            </a></div
        ></swiper-slide>
        <swiper-slide>
          <div class="index-banner bg4">
            <a>
              <img
                class="ani"
                swiper-animate-effect="fadeInUp"
                src="../assets/images/txt4.png"
              />
            </a></div
        ></swiper-slide>
      </swiper>
      <div class="banner-bot">
        <div class="swiper-button-prev"></div>
        <div class="swiper-pagination"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
    <LoginView
      v-show="loginStatus"
      @loginResult="loginBtn"
      @acceptUserName="accountName"
    ></LoginView>

    <Footer
      :wxColor="state.wxColor"
      :textColor="state.textColor"
      :font1="require('../assets/images/icon2.png')"
      :font2="require('../assets/images/icon3.png')"
      :font3="require('../assets/images/icon4.png')"
    ></Footer>
  </div>
</template>

<script setup>
import { Swiper, SwiperSlide } from "swiper/vue"; // swiper所需组件
// 这是分页器和对应方法，swiper好像在6的时候就已经分离了分页器和一些其他工具
import { A11y, Autoplay, Navigation, Pagination } from "swiper";
// 引入swiper样式，对应css 如果使用less或者css只需要把scss改为对应的即可
import Footer from "@/components/Footer.vue";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { onMounted, reactive, toRefs } from "vue";
import { useRouter } from "vue-router";
import Header from "../components/Header.vue";
import LoginView from "../components/LoginView.vue";
import { swiperAnimate, swiperAnimateCache } from "../utils/animate";
// setup语法糖只需要这样创建一个变量就可以正常使用分页器和对应功能，如果没有这个数组则无法使用对应功能
const modules = [Autoplay, Pagination, Navigation, A11y];

const init = (e) => {
  swiperAnimateCache();
  swiperAnimate(e);
};
const slideChangeTransitionEnd = (e) => {
  swiperAnimate(e);
};
const state = reactive({
  tabColor: "#fff",
  wxColor: "#fff",
  textColor: "#fff",
  loginStatus: false,
  userName: "",
});
const { loginStatus, userName } = toRefs(state);

const router = useRouter();
const getTabIndex = (item) => {
  router.push({ name: item.url });
};
// 处理login弹窗
const loginBtn = (item) => {
  loginStatus.value = item;
};
// 账号信息
const accountName = (name) => {
  userName.value = name;
};

// 本地缓存取账号信息
const getAccountName = () => {
  let account = localStorage.getItem("userName");
  userName.value = account;
};
onMounted(() => {
  getAccountName();
});

// // 处理login弹窗
// const loginPop = (item) => {
//   loginStatus.value = item;
// };
</script>

<style lang="scss" scoped>
.index-container {
  .main-header {
    position: absolute;
    z-index: 99;
    top: 0;
    left: 0;

    margin: auto;

    // margin: 0 8.5px;
  }

  .swiper {
    .bg1 {
      background-image: url(@/assets/images/4.jpg);
    }

    .bg2 {
      background-image: url(@/assets/images/2.jpg);
    }

    .bg3 {
      background-image: url(@/assets/images/3.jpg);
    }

    .bg4 {
      background-image: url(@/assets/images/1.jpg);
    }
  }

  .main-footer {
    .foot-wx {
      color: #fff !important;
    }
  }
}
</style>
